import { usePageState } from '../../store/useAppStore';
import { Title } from '../common/Title';

export const LoadingScreen: React.FC = () => {
  const { currentPage, loadingProgress } = usePageState();

  if (currentPage !== 'loading') {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-[#f7f7f7] flex flex-col items-center justify-center p-8">
      <div className="absolute top-8 left-8">
        <Title />
      </div>
      <div className="text-3xl text-black/40 animate-fade-in">
        Portfolio in development – Updates coming soon
      </div>
      <div className="absolute bottom-8 right-8 text-6xl [font-variant-numeric:tabular-nums] text-black">
        {Math.round(loadingProgress)}%
      </div>
    </div>
  );
};
